import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Table } from "../../../Table/Table";
import Loading from "../../../Loadings/LoadingTable";
import { MdDeleteForever } from "react-icons/md";
import { FiEdit, FiUpload } from "react-icons/fi";
import Button from "../../../Button/Button";
import { useGetBrandList } from "../../../../hooks/useContent";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  ContentUnitModal,
  RefreshTableBrand,
} from "../../../../shared/content-unit";
import { ButtonContainer } from "../LevelFirst/LevelFirstTable";
import { RenderTooltip } from "../../../Tooltip/Tooltip";
import BrandChangeStatusModal from "../../../Dialog/BrandChangeStatusModal";
import { EditBrandSeoModal } from "../../../Dialog/EditBrandSeoModal";

function BrandTable() {
  const refresh = useRecoilValue(RefreshTableBrand);

  const [pageNumber, setPageNumber] = useState(1);
  const [search, setSearch] = useState("");

  const { data, isLoading, refetch, hasNextPage, fetchNextPage } =
    useGetBrandList(pageNumber, search);
  const [show, setShow] = useState(false);
  const [showSeo, setShowSeo] = useState(false);
  const [item, setItem] = useState();
  const [brandId, setBrandId] = useState();
  const [moduals, setModuals] = useRecoilState(ContentUnitModal);
  let categoryList = data?.data?.brands;
  let pageCount = data?.pages[0]?.data?.count;

  useEffect(() => {
    refetch(pageNumber);
    categoryList = [];
  }, [refresh]);

  const headerTitle = [
    "#",
    "نام برند",
    "نام دسته بندی",
    "وضعیت",
    "نام برند انگلیسی",
    "نام برند عربی",
    "عکس",
    "عملیات",
  ];

  const handleDeleteCatergory = (category) => {
    setModuals({
      ...moduals,
      deleteBrand: { value: category, isShow: true },
    });
  };

  const handleUpdateCategory = (item) => {
    setModuals({ ...moduals, updateBrand: { value: item, isShow: true } });
  };

  // handle next page
  const handleNext = () => {
    if (pageNumber < pageCount) setPageNumber((prevState) => prevState + 1);
  };

  // handle previos page
  const handlePrevios = () => {
    if (pageNumber === 1) {
      setPageNumber(1);
    } else {
      setPageNumber((prevState) => prevState - 1);
    }
  };

  const baseURlImg = "https://apicampozit.mahanskinclinic.com/thumbnail/Brand/";

  useEffect(() => {
    let fetching = false;
    const onScroll = async (event) => {
      const { scrollHeight, scrollTop, clientHeight } =
        event.target.scrollingElement;
      if (!fetching && scrollHeight - scrollTop <= clientHeight * 2.5) {
        fetching = true;
        if (hasNextPage) await fetchNextPage();
        fetching = false;
      }
    };
    document.addEventListener("scroll", onScroll);
    return () => {
      document.removeEventListener("scroll", onScroll);
    };
  }, [fetchNextPage, hasNextPage]);

  let i = 0;

  const items = data ? (
    data?.pages?.map((page) =>
      page?.data?.brands?.map((item, index) => {
        return (
          <tr key={index}>
            <td>
              <span className="text-muted fw-bold text-muted d-block fs-7">
                {(i += 1)}
              </span>
            </td>
            <td>
              <span className="text-muted fw-bold text-muted d-block fs-7">
                {item?.NameBrands ? item?.NameBrands : ""}
              </span>
            </td>
            <td>
              <span className="text-muted fw-bold text-muted d-block fs-7">
                {item?.category ? item?.category?.NameCategories : ""}
              </span>
            </td>
            <td>
              <span className="text-muted fw-bold text-muted d-block fs-7">
                {item.StatusBrands === 1
                  ? "فعال"
                  : item.StatusBrands === 0
                  ? "غیر فعال"
                  : ""}
              </span>
            </td>
            <td>
              <span className="text-muted fw-bold text-muted d-block fs-7">
                {item?.NameEnglishBrands ? item?.NameEnglishBrands : ""}
              </span>
            </td>
            <td>
              <span className="text-muted fw-bold text-muted d-block fs-7">
                {item?.NameLanguageBrands ? item?.NameLanguageBrands : ""}
              </span>
            </td>
            <td>
              <span className="text-muted fw-bold text-muted d-block fs-7">
                <img
                  className="slider-image-table"
                  src={`${baseURlImg}${item?.LogoBrands}`}
                  alt={"عکس لوگو"}
                />
              </span>
            </td>
            <td>
              <ButtonContainer>
                <RenderTooltip title={"حذف برند"}>
                  <Button
                    size="12px"
                    bgColor="#C82333"
                    small="40px"
                    color="#fff"
                    style={{
                      marginLeft: "1rem",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    onclick={(e) => {
                      handleDeleteCatergory(item);
                    }}
                  >
                    <MdDeleteForever size={20} />
                  </Button>
                </RenderTooltip>
                <RenderTooltip title={"ویرایش  برند"}>
                  <Button
                    size="12px"
                    bgColor="#0D6EFD"
                    small="40px"
                    color="#fff"
                    className="mr-2"
                    onclick={(e) => {
                      handleUpdateCategory(item);
                    }}
                  >
                    <FiEdit size={20} />
                  </Button>
                </RenderTooltip>
                <RenderTooltip title={"تغییر وضعیت"}>
                  <Button
                    size="12px"
                    bgColor="#44a081"
                    small="40px"
                    color="#fff"
                    className="me-3"
                    onclick={(e) => {
                      setBrandId(item.IdBrands);
                      setShow(true);
                    }}
                  >
                    <FiUpload size={20} />
                  </Button>
                </RenderTooltip>
                <RenderTooltip title={"سئو برند"}>
                  <Button
                    size="12px"
                    bgColor="#F1416C"
                    small="40px"
                    color="#fff"
                    className="me-3"
                    onclick={(e) => {
                      setShowSeo(true);
                      setItem(item);
                    }}
                  >
                    <FiUpload size={20} />
                  </Button>
                </RenderTooltip>
              </ButtonContainer>
            </td>
          </tr>
        );
      })
    )
  ) : (
    <Loading />
  );

  return (
    <CategoryTableStyle>
      <Table
        headerTitle={headerTitle}
        title={`برند هایی که تا کنون ثبت کرده اید: ${
          pageCount ? pageCount : ""
        }`}
        items={items}
        setSearch={setSearch}
      />
      <BrandChangeStatusModal
        show={show}
        handleClose={() => setShow(false)}
        brandId={brandId}
      />
      <EditBrandSeoModal
        handleClose={() => setShowSeo(false)}
        show={showSeo}
        item={item}
      />
    </CategoryTableStyle>
  );
}

const CategoryTableStyle = styled.div`
  width: 100%;
  margin-top: 1rem;

  .slider-image-table {
    width: 90px;
    height: 60px;
    object-fit: contain;
    border-radius: 0.5rem;
  }
`;

export default BrandTable;
